'use client';

import React from 'react';

type ButtonVariant = 'secondary' | 'outlined' | 'ghost' | 'default';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'small' | 'middle' | 'large';
  danger?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  htmlType?: 'button' | 'submit' | 'reset';
  block?: boolean;
  extraHeight?: boolean;
  halfRight?: boolean;
}

export default function Button({
  halfRight,
  variant = 'default',
  size,
  danger,
  loading,
  icon,
  htmlType = 'button',
  block,
  extraHeight,
  disabled,
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = [
    'ui-btn',
    variant,
    size,
    danger && 'danger',
    loading && 'loading',
    block && 'block',
    extraHeight && 'extra-height',
    halfRight && 'half-right',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={htmlType} disabled={disabled || loading} className={classes} {...rest}>
      {loading && <span className="spinner" />}
      {icon && <span className="icon">{icon}</span>}
      {children}
    </button>
  );
}
